import { schedulingStepsNames } from '../components/common/ShippingSchedulingSteps';

export const PROMOTION_NAME = '1 Day Offer 2024';

export const PromoDetails = {
  enabled: () => true,
  sessionStorageKey: 'promoBannerSSKey',
  onlyForSteps: schedulingStepsNames,
  promoLocked: '',
  terms: '',
};
